import { useFlags } from "flagsmith/react";
import { USER_FLAGS_ENUM } from "@utils/featureFlags";
import { parseCommaSeparatedList } from "@utils/index";

/**
 * Hook para controlar o campo de frete (CIF/FOB) via feature flag.
 *
 * - ENABLE_FREIGHT_CONTROL:
 *   - Flag ON: campo habilitado (comportamento normal)
 *   - Flag OFF: campo desabilitado (visível, porém sem interação)
 *
 * - DISABLE_FREIGHT_BY_CENTER:
 *   - Flag ON + value com lista de centros (ex: "CDM1,CDM2,C001"):
 *     desabilita o frete quando o centro informado estiver na lista.
 *   - Flag OFF: não interfere.
 *
 * @param center - código do centro/filial atual (ex: filialID)
 */
export const useFreightControl = (center?: string) => {
  const flags = useFlags([
    USER_FLAGS_ENUM.ENABLE_FREIGHT_CONTROL,
    USER_FLAGS_ENUM.DISABLE_FREIGHT_BY_CENTER,
  ]);

  const isFreightEnabled =
    flags[USER_FLAGS_ENUM.ENABLE_FREIGHT_CONTROL]?.enabled !== false;

  const disableByCenterFlag = flags[USER_FLAGS_ENUM.DISABLE_FREIGHT_BY_CENTER];
  const isDisableByCenterEnabled = disableByCenterFlag?.enabled === true;

  const disabledCenters: string[] = isDisableByCenterEnabled
    ? parseCommaSeparatedList(disableByCenterFlag?.value)
    : [];

  const isCenterBlocked =
    isDisableByCenterEnabled &&
    !!center &&
    disabledCenters.includes(center.toUpperCase());

  return {
    isFreightEnabled: isFreightEnabled && !isCenterBlocked,
    isFreightDisabled: !isFreightEnabled || isCenterBlocked,
    isCenterBlocked,
  };
};
